import { render, staticRenderFns } from "./LawyerProfile.vue?vue&type=template&id=7b1c5efc&"
import script from "./LawyerProfile.vue?vue&type=script&lang=ts&"
export * from "./LawyerProfile.vue?vue&type=script&lang=ts&"
import style0 from "./LawyerProfile.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports